import { styled, css } from '@mui/material/styles';
import { Tabs, Tab } from '@mui/material';

export const StyledTabs = styled(Tabs)(
  () => css`
    position: relative;
    min-height: 5.2rem;

    .MuiTabs-flexContainer {
      padding: 1rem 1.8rem;
      gap: 0.6rem;

      &::after {
        content: '';
        display: block;
        width: 1.8rem;
        min-width: 1.8rem;
        height: 1.8rem;
      }
    }

    .MuiTabs-indicator {
      display: none;
    }

    .MuiTabScrollButton-root {
      position: absolute;
      z-index: 1;
      opacity: 1;
      width: 2.2rem;
      min-height: inherit;
      transition: all 0.3s ease-in-out;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(2px);

      &.Mui-disabled {
        opacity: 0;
        width: 0;
      }

      &:last-of-type {
        right: 0;
      }
    }
  `
);

export const StyledTab = styled(Tab)(
  ({ theme }) => css`
    display: flex;
    gap: 0.6rem;
    height: 3.2rem;
    min-height: 0;
    border-radius: 3.2rem;
    padding: 1rem;
    box-sizing: border-box;
    text-transform: none;
    line-height: 1em;
    font-size: ${theme.typography.body2.fontSize};
    font-weight: ${theme.typography.body2.fontWeight};
    color: ${theme.palette.neutral.var60};
    background: ${theme.palette.neutral.var20};

    &.Mui-disabled {
      color: ${theme.palette.neutral.var40};
      background: ${theme.palette.neutral.var10};
    }

    &.Mui-selected {
      color: ${theme.palette.neutral.var0};
      background: ${theme.palette.neutral.var100};
    }

    .MuiTab-iconWrapper {
      margin: 0;
    }
  `
);

export const TabCounter = styled('span')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.6rem;
    padding: 0 0.8rem;
    border-radius: 1.6rem;
    background: ${theme.palette.neutral.var30};

    .Mui-disabled & {
      color: ${theme.palette.neutral.var50};
      background: ${theme.palette.neutral.var30};
    }

    .Mui-selected & {
      color: ${theme.palette.neutral.var100};
      background: ${theme.palette.neutral.var0};
    }
  `
);
